import React from 'react';
import styled from 'styled-components';
import {
  Button,
  Drawer,
  Grid,
  IconButton,
  Typography
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import { StyledInlineFormGrid } from './inline/InlineForm';

const StyledDrawerContent = styled.div`
  padding: 20px;
  .spacer {
    flex: 1;
  }
  .header {
    margin-bottom: 8px;
    .title {
      display: flex;
      align-items: center;
    }
  }
  .actions {
    margin-top: 24px;
    & > :not(:first-child) {
      margin-left: 10px;
    }
  }
`;

export interface BaseSearchFilterProps<Options> {
  onFilter?: (options: Options) => void;
}

export interface SearchFilterDrawerProps {
  open?: boolean;
  title?: string;
  width?: number;
  clearLabel?: string;
  filterLabel?: string;
  className?: string;
  children?: React.ReactNode;
  onClose?: () => void;
  onFilter?: () => void;
  onClear?: () => void;
}

const SearchFilterDrawer: React.FC<SearchFilterDrawerProps> = (
  props: SearchFilterDrawerProps
) => {
  const {
    open,
    className,
    width = 360,
    title = 'Filter',
    clearLabel = 'Clear All',
    filterLabel = 'Filter',
    onClose,
    onFilter,
    onClear
  } = props;

  return (
    <Drawer
      keepMounted
      anchor='right'
      open={open}
      className={className}
      onClose={onClose}
    >
      <StyledDrawerContent style={{ width }} className='drawer-content'>
        <Grid container className='header'>
          <Grid item className='title'>
            <Typography variant='h6'>{title}</Typography>
          </Grid>
          <div className='spacer' />
          <Grid item>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>

        <StyledInlineFormGrid container wrap='wrap' spacing={2}>
          {props.children}
        </StyledInlineFormGrid>

        <div className='actions'>
          <Button color='primary' variant='contained' onClick={onFilter}>
            {filterLabel}
          </Button>
          <Button color='primary' variant='outlined' onClick={onClear}>
            {clearLabel}
          </Button>
        </div>
      </StyledDrawerContent>
    </Drawer>
  );
};

export default SearchFilterDrawer;
